var _rect, _rect2, _rect3, _rect4, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint0_linear_3954_2049)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "url(#paint1_linear_3954_2049)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint2_linear_3954_2049)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 6.5,
    y: 6.5,
    width: 35,
    height: 35,
    rx: 17.5,
    stroke: "url(#paint3_linear_3954_2049)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3954_2049)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.3333 31.4167C29.8859 31.4167 30.4158 31.1972 30.8065 30.8065C31.1972 30.4158 31.4167 29.8859 31.4167 29.3333V18.0833C31.4167 17.5308 31.1972 17.0009 30.8065 16.6102C30.4158 16.2195 29.8859 16 29.3333 16C28.7808 16 28.2509 16.2195 27.8602 16.6102C27.4695 17.0009 27.25 17.5308 27.25 18.0833V29.3333C27.25 29.8859 27.4695 30.4158 27.8602 30.8065C28.2509 31.1972 28.7808 31.4167 29.3333 31.4167ZM23.7083 31.4167C24.2609 31.4167 24.7908 31.1972 25.1815 30.8065C25.5722 30.4158 25.7917 29.8859 25.7917 29.3333V22.6667C25.7917 22.1141 25.5722 21.5842 25.1815 21.1935C24.7908 20.8028 24.2609 20.5833 23.7083 20.5833C23.1558 20.5833 22.6259 20.8028 22.2352 21.1935C21.8445 21.5842 21.625 22.1141 21.625 22.6667V29.3333C21.625 29.8859 21.8445 30.4158 22.2352 30.8065C22.6259 31.1972 23.1558 31.4167 23.7083 31.4167Z",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0833 31.4167C19.2339 31.4167 20.1667 30.4839 20.1667 29.3333C20.1667 28.1827 19.2339 27.25 18.0833 27.25C16.9327 27.25 16 28.1827 16 29.3333C16 30.4839 16.9327 31.4167 18.0833 31.4167Z",
    stroke: "#FFD119",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3954_2049",
    x1: 3.95122,
    y1: 50.6341,
    x2: 50.1951,
    y2: -3.21951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3954_2049",
    x1: 47.8537,
    y1: -6.14634,
    x2: 3.95122,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3954_2049",
    x1: 2.08064,
    y1: 8.03226,
    x2: 41.8548,
    y2: 42,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.323723,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3954_2049",
    x1: 49.1129,
    y1: 50.129,
    x2: 7.30645,
    y2: 20.5161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFD119"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.576615,
    stopColor: "#FFD119",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3954_2049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalytics);
export default __webpack_public_path__ + "static/media/analytics.2b670f45412043887960252b00eb9cef.svg";
export { ForwardRef as ReactComponent };